<template>
  <div class="d-flex justify-space-between my-2">
    <div class="w-25 pr-5">
      <v-text-field
        label="Order number"
        v-model="orderNumber"
        @focus="orderNumber = ''"
        @blur="
          orderNumber == '' || orderNumber == null ? (orderNumber = ' ') : ''
        "
        @change="$emit('update:orderNumber', $event)"
        placeholder=" "
        dense
        outlined
        append-icon="shopping_basket"
        hide-details
      >
      </v-text-field>
    </div>
    <div class="w-25 pr-5">
      <v-autocomplete
        :items="surgeries"
        label="Surgery"
        v-model="surgeryId"
        @change="$emit('update:surgeryId', $event)"
        dense
        outlined
        append-icon="apartment"
        item-text="name"
        item-value="id"
        hide-details
      ></v-autocomplete>
    </div>
    <div class="w-25 pr-5">
      <v-autocomplete
        :items="orderStatuses"
        v-model="orderStatus"
        @change="$emit('update:orderStatus', $event)"
        label="Order Status"
        dense
        outlined
        append-icon="tab"
        item-text="name"
        item-value="id"
        hide-details
      ></v-autocomplete>
    </div>
    <div class="w-25 text-right">
      <v-btn class="px-2 w-100" color="primary" @click="$emit('apply')"
        >Apply filters</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    orderNumber: {
      type: String,
      default: " "
    },
    surgeryId: {
      type: String,
      default: null
    },
    orderStatus: {
      type: String,
      default: null
    }
  },
  computed: {
    surgeries() {
      let surgeries = this.$store.state.surgeries.surgeries;
      surgeries.unshift({
        name: "",
        id: null
      });
      return surgeries;
    },
    orderStatuses() {
      return this.$store.state.orders.orderStatuses;
    }
  },
  async mounted() {
    await this.$store.dispatch("surgeries/LOAD_SURGERIES", {
      from: 0,
      to: 0
    });
    await this.$store.dispatch("orders/LOAD_ORDER_STATUSES", {
      from: 0,
      to: 0
    });
  },
  data() {
    return {
      paymentStatuses: [
        {
          text: "",
          value: null
        },
        {
          text: "Pending",
          value: "pending"
        },
        {
          text: "Processing",
          value: "processing"
        },
        {
          text: "Processed",
          value: "processed"
        },
        {
          text: "Payment Failed",
          value: "payment_failed"
        }
      ]
    };
  }
};
</script>
